import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class OrderAlertService {
  private readonly audio = new Audio('assets/sounds/new-order.mp3');
  private readonly reminderAudio = new Audio('assets/sounds/reminder-order.mp3');
  private unlocked = false;

  public unlockAudio(): void {
    if (this.unlocked) return;

    this.audio
      .play()
      .then(() => {
        this.audio.pause();
        this.audio.currentTime = 0;
        this.unlocked = true;
      })
      .catch(() => {});
  }

  public playAlertSound(): void {
    this.audio.currentTime = 0;
    this.audio.play().catch(() => {});
  }

  public playReminderSound(): void {
    this.reminderAudio.currentTime = 0;
    this.reminderAudio.play().catch(() => {});
  }

  public requestPermission(): void {
    if (!('Notification' in window)) return;
    if (Notification.permission === 'default') {
      Notification.requestPermission();
    }
  }

  public notify(title: string, body: string, onClick: () => void): void {
    if (!('Notification' in window) || Notification.permission !== 'granted') return;

    const n = new Notification(title, { body });
    n.onclick = () => {
      window.focus();
      onClick();
      n.close();
    };
  }
}
